import { render, staticRenderFns } from "./customer6.vue?vue&type=template&id=1aabde31&scoped=true"
import script from "./customer6.vue?vue&type=script&lang=js"
export * from "./customer6.vue?vue&type=script&lang=js"
import style0 from "../../Styles/cover.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../Styles/common.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "../../Styles/iconfont/iconfont.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./customer6.vue?vue&type=style&index=3&id=1aabde31&prod&lang=css"
import style4 from "./customer6.vue?vue&type=style&index=4&id=1aabde31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabde31",
  null
  
)

export default component.exports